<template>
	<div id="novel_chapter">
		<div class="novel_chapter">
			<div class="novel_list">
				<div class="novel_list1 cursor_1" @click="toNovellist">
					<img src="@/assets/image/icon_right.png" alt="">
					{{ novelInfo.name }}
				</div>

				<div class="flex-row">
					<!-- <div class="novel_chapter2 cursor_1" v-if="!isInit" @click="updateText">
						上传正文
					</div> -->
					<div class="novel_chapter3 cursor_1 t-m-l-25" @click="nextStep">
						续写章节
					</div>
				</div>

			</div>
			<div class="novel_chapter1">
				<div class="novel_chapter1_1">
					<!-- 表格标题 -->
					<div class="novel_chapter1_2" v-if="empty">
						<div class="novel_chapter1_3" v-for="(item, i) in chapterTitle" :key="i">
							{{ item }}
						</div>
					</div>
					<div class="novel_chapter1_2" v-else>
						 <noData></noData>
					</div>
					<!-- 章节 -->
					<div class="novel_chapter1_2" v-for="(item, i) in chapterList" :key="i" @click.self="lookChapter(i,1)">
						<div class="novel_chapter1_4" style="width: 5%;">{{ item.number }}</div>
						<div class="novel_chapter1_4 novel_chapter1_5" style="width: 30%;">{{ item.name }}</div>
						<div class="novel_chapter1_4" style="width: 10%;">{{ item.textNumber }}</div>
						<div class="novel_chapter1_4" style="width: 20%;">{{ item.createTime }}</div>
						<div class="novel_chapter1_4" style="width: 10%;display: flex;align-items: center;justify-content: center;">
							<div
								:class="item.statusInstructions == '未完成' ?
									'novel_chapter1_8 novel_chapter1_9' : item.statusInstructions == '创作中' ? 'novel_chapter1_30' : 'novel_chapter1_8'">
							</div>
							{{ item.statusInstructions }}
						</div>
						<div class="novel_chapter1_4" style="flex: 1;display: flex;align-items: center;justify-content: center;">
							<div v-if="item.statusInstructions == '已完成' || item.statusInstructions == '创作中'"
								class="novel_chapter1_12 cursor_1" @click="editchapter(i, 1)">编辑章节</div>
							<div v-if="item.statusInstructions == '已完成' || item.statusInstructions == '创作中'"
								class="novel_chapter1_12 cursor_1" @click="copy(item.textId)">复制正文</div>
							<div v-if="item.statusInstructions == '未完成' && item.current" class="novel_chapter1_11">
								<div class="novel_chapter1_12 cursor_1" @click="editchapter(i, 2)">手写正文</div>
								<div class="novel_chapter1_12 cursor_1" @click="editchapter(i, 3)">AI写正文</div>
							</div>
							<div class="novel_chapter1_11">
								<div class="novel_chapter1_12 cursor_1" @click="delChapters(item, i)">删除</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<bottomPage v-show="total" :total="total" @currentNUm="currentNUm" ref="bottompage"></bottomPage>
		<!-- <outlineContinuous :novelId="novelInfo.id" ref="outlineContinuous" @getContinued="getContinued">
		</outlineContinuous> -->
		<loadingStatus v-if="loading" />
	</div>
</template>

<script>
import { copy } from '@/utils/utils'
import bottomPage from '@/components/bottom_page.vue' //底部分页
import outlineContinuous from '@/components/outline_continuous.vue'
import loadingStatus from '@/components/loading_status.vue' //加载
import noData from '@/components/no_data.vue';
import api from '@/api/api';
import SApi from '@/api/script';
import { EncryptionUtil } from '@/utils/encrypt'
export default {
	components: {
		bottomPage, outlineContinuous, loadingStatus,noData
	},
	data() {
		return {
			chapterTitle: ['章节', '章节名称', '字数', '发布时间', '状态', '操作'],
			chapterList: [],
			total: null, //总条数,
			pageNum: 1,
			pageSize:10,
			novelInfo: {}, //小说信息
			newNumber: null, //最新章节
			isInit: false,//默认false 是初始化，true，不是初始化
			loading: true, //加载
			empty:true,
		}
	},
	created() {

	},
	methods: {
		toNovellist() {
			// this.$emit('toNovellist')
			this.$router.replace({ path: '/scriptList' })
		},
		async getChapterList(noveldata) {
			console.log(noveldata)
			if (!noveldata) return
			this.novelInfo = noveldata;
			let key = this.getChapterSearchKey(this.dChapterSearchKey, this.novelInfo.id)
			const novelChapterSearch = JSON.parse(localStorage.getItem(key)) || {}
			console.log(novelChapterSearch)
			this.pageNum = novelChapterSearch?.pageNum || 1
			await this.getDJNewChapter(noveldata.id);
			try {
				if (this.$refs.bottompage) {
					this.$refs.bottompage.page(this.pageNum)
				}

				const res = await SApi.getDjOutlineListV2({ scriptId: noveldata.id,pageNum:this.pageNum,pageSize:this.pageSize });
				if (res.code === 200) {
					let firstStatus = false;
					this.total = res.total;
					if(!this.total){
						this.toNovellist()
						return
					}
					this.chapterList = res.rows && res.rows.map(item => {
						if (this.newNumber == item.number && !firstStatus) {
							firstStatus = true;
							return { ...item, current: true };
						}
						return { ...item, current: false };
					});
					this.empty = res.rows.length > 0 ? true : false
					this.isInit = this.chapterList.some(item => item.statusInstructions === '已完成' || item.statusInstructions == '创作中')
				}
				this.loading = false
			} catch (error) {
				console.error('获取章节列表出错:', error);
				this.loading = false
			}
		},
		async getDJNewChapter(id) {
			try {
				const res = await SApi.getDJNewChapter(id);
				if (res.code === 200) {
					if (res.data === '章节都已完成') {
						this.newNumber = '章节都已完成';
					} else {
						this.newNumber = res.data.number;
					}
				}
			} catch (error) {
				console.error('获取最新章节出错:', error);
			}
		},
		lookChapter(i,edit){
			if(this.chapterList[i].statusInstructions == '已完成' || this.chapterList[i].statusInstructions == '创作中'){
				this.editchapter(i,edit)
			}
		},
		delChapters(item, index) {
			let text = ''
			if (index == this.total - 1) {
				text = `是否需要删除从第${index + 1}章，删除后无法恢复，请慎重操作`
			} else {
				text = `是否需要删除从第${index + 1}章到后面所有的章节，删除后对应的章节和正文都会删除，且无法恢复，请慎重操作`
			}
			this.$confirm(text, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				SApi.delScriptChapter({ id: item.id }).then(res => {
					if (res.code === 200) {
						this.$message.success('删除成功')
						this.getChapterList(this.novelInfo)
					}
				})
			})
		},
		// 编辑 1编辑 2手写 3Ai生成
		editchapter(i, edit) {
			let prevTextId = ''
			// if(i>0 && this.chapterList[i].number > 1){
			//     prevTextId = this.chapterList[i-1].textId
			// }
			let editItem = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				editText: edit,
				chapter: this.chapterList[i].number,
				chapterId: this.chapterList[i].id,
				chapterName: this.chapterList[i].name,
				// prevTextId: prevTextId,
				textId: this.chapterList[i].textId,
				pageNum: this.pageNum,
				pageSize: 10,
				isAICreateZj: edit > 1 ? true : false,
				asc: 'asc'
			};
			console.log('章节id=', this.chapterList[i].textId)
			sessionStorage.setItem('editItem', JSON.stringify(editItem));
			this.$router.push({ path: '/scriptOutline' });
		},
		//续写大纲
		nextStep() {
			// this.$refs.outlineContinuous.openPopup();
			this.getContinued()
		},
		//选择条件
		getContinued() {
			let editItem = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				editType: 3,
				backNum: 1,
				isAiCreate: true
			};
			sessionStorage.setItem('editItem', JSON.stringify(editItem));
			this.$router.push({ path: '/scriptOutline' });
		},
		//复制
		copy(textId) {
			SApi.getDjOutline({ id: textId }).then(async(res) => {
                if (res.code == 200) {
					let tc = res.data.textTitle + '\n' + this.stripHtmlTags(res.data.textContent)
					const success = await copy(this.stripHtmlTags(tc));
					if (success) {
						this.$message.success('复制成功');
					} else {
						this.$message.error('复制失败');
					}
                }
            })
		},
		currentNUm(pageNum) {
			this.pageNum = pageNum
			//分页记录缓存
			let key = this.getChapterSearchKey(this.dChapterSearchKey, this.novelInfo.id)
			localStorage.setItem(key, JSON.stringify({ pageNum }))
			this.getChapterList(this.novelInfo)
		},
		//上传正文
		updateText() {
			if (this.novelInfo && !this.novelInfo.id) return
			this.$router.push({
				path: '/chapterUpdate', query: {
					novelId: this.novelInfo.id,
					pageNum: this.pageNum,
					pageSize: 10,
					novelInfo: EncryptionUtil.encrypt(this.novelInfo)
				}
			})
		}
	}
}
</script>

<style scoped>
#novel_chapter {
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
}

.novel_list {
	display: flex;
	align-items: center;
	height: 77px;
	justify-content: space-between;
	border-bottom: 1px solid #e6ebf0;
	padding: 0 25px;
}

.novel_list1 {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	font-weight: 700;
	font-size: 19px;
	color: #111;
}

.novel_chapter {
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	background-color: #FFFFFF;
	box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
	border-radius: 8px;
	overflow: hidden;
	margin-bottom: 15px;
}

.novel_chapter1 {
	height: calc(100% - 78px);
	overflow-y: auto;
	-ms-overflow-style: none;
	scrollbar-width: none;
	padding: 25px;
}

.novel_chapter1_1 {
	height: 100%;

}

.novel_chapter1_2 {
	display: flex;
	width: 100%;
}

.novel_chapter1_3 {
	font-size: 15px;
	color: #333333;
	height: 50px;
	line-height: 50px;
	background-color: #F5F7FA;
	border-right: 1px solid #E6EBF0;
	border-bottom: 1px solid #E6EBF0;
}


.novel_chapter1_3:first-child {
	width: 5%;
	text-align: center;
}

.novel_chapter1_3:nth-child(2) {
	width: 30%;
	text-align: center;
}

.novel_chapter1_3:nth-child(3){
    width: 10%;
	text-align: center;
}
.novel_chapter1_3:nth-child(4) {
	width: 20%;
	text-align: center;
}
.novel_chapter1_3:nth-child(5){
	width: 10%;
	text-align: center;
}
.novel_chapter1_3:nth-child(6) {
	flex: 1;
	text-align: center;
	border-right: none;
}

.novel_chapter1_4 {
	height: 50px;
	text-align: center;
	line-height: 50px;
	border-bottom: 1px solid #E6EBF0;
	font-size: 15px;
	color: #111111;
}

.novel_chapter1_5 {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.novel_chapter1_8 {
	width: 10px;
	height: 10px;
	background: #01CC7A;
	border-radius: 50%;
	margin-right: 5px;
}

.novel_chapter1_30 {
	width: 10px;
	height: 10px;
	background: #548AFF;
	border-radius: 50%;
	margin-right: 5px;
}

.novel_chapter1_9 {
	background: #FFB400;
}

.novel_chapter1_10 {
	justify-content: start;
	padding-left: 10px;
}

.novel_chapter1_11 {
	display: flex;
}

.novel_chapter1_12 {
	color: #548AFF;
	margin-right: 8px;
}

.novel_chapter2 {
	width: 104px;
	height: 38px;
	line-height: 38px;
	font-size: 16px;
	color: #FFFFFF;
	background: var(--tech-primary);
	background-repeat: no-repeat;
	background-size: 20px 20px;
	border-radius: 4px;
	text-align: center;
	cursor: pointer;
}

.novel_chapter3 {
	width: 104px;
	height: 38px;
	line-height: 38px;
	font-size: 16px;
	color: #FFFFFF;
	background: var(--tech-primary);
	background-image: url('@/assets/image/icon_list7.png');
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: 5px center;
	border-radius: 4px;
	padding-left: 28px;
	cursor: pointer;
}

/* .novel_chapter3:hover {
	color: var(--tech-primary);
	background: var(--tech-btn-Lightblue);
	background-image: url('../assets/image/icon_list1.png');
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: 5px center;
} */
</style>